import * as Post from '../constants/Post';

const initialState = {
  post: null,
  createLoaded: false,
  createdId: null,
  destroyed: null,
  previewPost: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Post.POST_CREATE:
      return state;
    
    case Post.POST_CREATE_RESULT:
      return Object.assign({}, state, {
        createLoaded: true,
        createdId: action.createdId
      });

    
    case Post.POST_INFO_GET:
      return state
    
    case Post.POST_INFO_GET_RESULT:
      if (action.preview) {
        return Object.assign({}, state, {
          previewPost: action.post
        });
      } else {
        return Object.assign({}, state, {
          post: action.post
        });
      }

    case Post.POST_INFO_REMOVE:
      return Object.assign({}, state, {
        post: null
      });
    
    case Post.POST_UPDATE_RESULT:
      return Object.assign({}, state, {
        post: action.post
      });
    

    
    case Post.POST_DESTROY:
      return state;
    case Post.POST_DESTROY_RESULT:
      return Object.assign({}, state, {
        destroyed: true
      });
    case Post.POST_DESTROY_FLAG_REMOVE:
      return Object.assign({}, state, {
        destroyed: null
      });
    
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/Post.js